module.exports = __webpack_public_path__ + "img/wo-logo-sm.f858f1da.png";